import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Tokens first: every other stylesheet reads the custom properties they
// define, and a component style loaded before them would resolve to nothing.
import "@hardauto/core-ui/tokens.css";
// The installation's brand, AFTER the system tokens: it overrides their values
// and nothing else. One file, so the second deployment is a deployment rather
// than a fork — §1 of docs/product/cadrage-hardauto.md.
import "@hardauto/core-ui/brand.css";
// The utilities every screen uses — aligned numbers, muted cells, the inline
// create form. They were duplicated in two feature stylesheets; they live in
// one place now, and they are imported here because a utility sheet has no
// component to hang off.
import "@hardauto/core-ui/utilities.css";
import "./app.css";

import { App } from "./app";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element #root is missing from index.html");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
